import Vue from 'vue'


class Login {
    constructor() {
    }
    noLogin(router) {
        router.replace("/login");
    }
}


// 1	运营管理员	系统默认角色（勿删）	        
// 2	医院系统管理员	系统默认角色（勿删）        
// 3	医院医生	系统默认角色（勿删）            
// 4	医院护士	系统默认角色(医院护士)          
// 5	系统管理员	系统默认角色（勿删）	        
// 6	市场管理员	系统默认角色（勿删）            
// 7	幼儿园管理员	系统默认角色（勿删）  院长      
// 8	财务人员(运营)	系统默认角色（勿删）        
// 9	数据管理员	公司	                        
// 10	幼儿园老师	幼儿园老师	                    
// 11	幼儿园保健医生	幼儿园保健医生	            
// 12	儿保所医生	儿保所医生	                    
// 13	区保健所医生	区保健所医生	            
// 14	幼儿园采购	            
// 20   家长




Vue.prototype.$UserInfo = {
    IP: '',                           //        最后登录的ip      
    Id: '',                           //        账户id      数据库的      
    LastLogin: '',                    //        最后登录的时间                                  
    LoginNumber: '',                  //        登录次数                                       
    Type: '',                         //        用户类型                               
    Address: '',                      //        用户地址                           
    UserId: '',                       //       *用户的id                               
    State: '',                        //        用户状态  2、已审核 1、未审核（待审核） 5、拒绝                                
    UserName: '',                     //        用户的登录的账户（手机号）                               
    HeadPicture: '',                  //        头像                                   
    OperatorId: '',                   //       *平台的id                               
    HospitalId: '',                   //       *单位id，幼儿园的id                               
    RealName: '',                     //        用户昵称                         
    HospitalName: '',                     //        单位的名称                           
    GradeClassId: '',                      //       *班级               
    GradeClassName: '',                    //        班级名字                   
    RoleDefaultId: '',                    //        角色权限                   
};

if (localStorage.UserInfo) {
    Vue.prototype.$UserInfo = JSON.parse(localStorage.UserInfo);
}





//取得用户数据
Vue.prototype.$getUserInfo = function (fun) {

    if (fun || Vue.prototype.$UserInfo.admin_id == -1) {
        //没有用户信息
        $.ajax({
            url: this.$serverDefault + "admin/getUserInfo",
            type: 'POST',
            data: {
                token: localStorage.token,
                admin_id: localStorage.admin_id,
            }, 
             headers: {
                // "Authorization": 'token ' + localStorage.token,
                 "Access-TimeSpan": new Date().valueOf(),
                 "Content-Type": "application/json",
             },
            async: false,
            success: (res) => {
                res = JSON.parse(res);
                if (res.res < -900) {
                    new Login().noLogin(this.$router);
                } else {
                    Vue.prototype.$UserInfo = res.msg
                    localStorage.UserInfo = JSON.stringify(res.msg);
                }
            },
        });
    }

    if (typeof fun == 'function') {
        fun(Vue.prototype.$UserInfo);
    } else {
        return Vue.prototype.$UserInfo;
    }
}

Vue.prototype.$get = function (url, data, success, error) {
    if (!data) data = {};

    if (data.token == null) {
        data.token = localStorage.token ? localStorage.token : '';
    }
    if (data.admin_id == null) {
        data.admin_id = localStorage.admin_id ? localStorage.admin_id : '';
    }

    if (url.indexOf("http") == -1) {
        //没有http
        url = this.$serverDefault + url;
    }

    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        xhrFields: {
            withCredentials: true
        },
        headers: {
            // "Authorization": 'token ' + localStorage.token,
             "Access-TimeSpan": new Date().valueOf(),
             "Content-Type": "application/json",
         },
        success: res => {
            if (res == '' || res == null || res == undefined) {
                return;
            }
            try {
                res = JSON.parse(res);
            } catch (e) {
                if (success) success(res, e);
                return false;
            }


            if (res['res']) {

                //登录验证
                if (res.res == -992 || res.res == -991) {
                    //登录失败跳转登录页
                    new Login().noLogin(this.$router);
                } else {
                    if (success) {
                        success(res);
                    }
                }

            } else {
                if (success) {
                    success(res);
                }
            }

        },
        error: () => {
            if (error) {
                let is = error(false, error);
                if (is) {
                    this.$error('系统错误 请联系客服！');
                }
            };

        }
    });
}

Vue.prototype.$post = function (url, data, success, error) {
    if (!data) data = {};

    // if (data.token == null) {
    //     data.token = localStorage.token ? localStorage.token : '';
    // }
    // if (data.admin_id == null) {
    //     data.admin_id = localStorage.admin_id ? localStorage.admin_id : '';
    // }


    // 添加参数 ======================================================
    // if (typeof data.operatorId == "undefined") {
    //     // data.operatorId = this.$UserInfo.OperatorId;//当运营方ID
    // }

    if (url.indexOf("http") == -1) {
        //没有http
        url = this.$serverDefault + url;
    }
    $.ajax({
        url: url,
        type: 'post',
        data: data,
        xhrFields: {
            // withCredentials: true
        },
        // crossDomain: true,

        headers: {
           // "Authorization": 'token ' + localStorage.token,
            "Access-TimeSpan": new Date().valueOf(),
            "Content-Type": "application/json",
        },
        // beforeSend: function (xhr) {
        //     xhr.setRequestHeader(`Authorization:'token ${localStorage.token}'`);
        //     xhr.setRequestHeader(`Access-TimeSpan:${new Date().valueOf()}`);
        // },
        // Access-Control-Allow-Headers:Authorization,Access-TimeSpan
        success: res => {

            if (res == '' || res == null || res == undefined) {
                if (error) error(res);
                return;
            }

            try {
                res = JSON.parse(res);
            } catch (e) {
                if (success) success(res, e);
                return false;
            }

            // if (res['res']) {

            //     //登录验证
            //     if (res.res == -992 || res.res == -991) {
            //         //登录失败跳转登录页
            //         new Login().noLogin(this.$router);
            //     } else {
            //         if (success) {
            //             success(res);
            //         }
            //     }

            // } else {
            //     if (success) {
            //         success(res);
            //     }
            // }


        },
        error: (e) => {
            if (e.status == 401) {
                this.$UserInfo = {
                    IP: '',                           //        最后登录的ip      
                    Id: '',                           //        账户id      数据库的      
                    LastLogin: '',                    //        最后登录的时间                                  
                    LoginNumber: '',                  //        登录次数                                       
                    Type: '',                         //        用户类型                                 
                    Address: '',                      //        用户地址                           
                    UserId: '',                       //       *用户的id                               
                    State: '',                        //        用户状态  2、已审核 1、未审核（待审核） 5、拒绝
                    UserName: '',                     //        用户的登录的账户（手机号）                               
                    HeadPicture: '',                  //        头像                                   
                    HospitalName: '',                   //       *单位id，幼儿园的单位的名称                             
                    RealName: '',                     //        用户昵称  。                   
                    GradeClassId: '',                      //       *班级               
                    GradeClassName: '',                    //        班级名字                   
                    RoleDefaultId: '',                    //        角色权限   
                }
                this.$warn('请重新登录~');
                this.$router.replace('/Login');
            } else {
                if (error) error(e, false);
            }
        }

    });

}

Vue.prototype.$strlength = function (str) {
    if (str == null || str == undefined) {
        str = 0;
    }
    return str.length;
}




